import React from "react";

import { Classroom } from "@examspark/types";

import ResourcesTable from "../resources/ResourcesTable";

const ClassroomResources = (props: { classroom: Classroom }) => (
  <ResourcesTable location={props.classroom} />
);

export default ClassroomResources;
